import React, { useState, useEffect } from 'react';
import './yAxisValueComponent.scss';
import GenericNumberInput from '../genericNumberInput/genericNumberInput';

export interface OptionCheckboxProps {
  option: any;
  onChangeHandler: any;
  onSetGoalValuesChange: any;
  childComponent: any;
  customValues: any;
}

const defaultValue = {
  min: 0,
  max: 100,
};

const YAxisValueComponent: React.FC<any> = ({ onSetGoalValuesChange, customValues }) => {
  const [yAxisValue, setYAxisValue] = useState<any>(customValues || defaultValue);
  const [isInvalidMinMaxValue, setIsInvalidMinMaxValue] = useState<boolean>(false);

  useEffect(() => {
    if (yAxisValue) {
      onSetGoalValuesChange(yAxisValue);
    }
  }, [yAxisValue]);

  const handleMinValue = (event: { target: { value: any } }) => {
    const yAxisMinValue = parseInt(event.target.value);
    setIsInvalidMinMaxValue(yAxisMinValue < 0 || yAxisMinValue > yAxisValue?.max);
    setYAxisValue({
      ...yAxisValue,
      min: yAxisMinValue,
    });
  };

  const handleMaxValue = (event: { target: { value: any } }) => {
    const yAxisMaxValue = parseInt(event.target.value);
    setIsInvalidMinMaxValue(yAxisMaxValue < 0 || yAxisMaxValue < yAxisValue?.min);
    setYAxisValue({
      ...yAxisValue,
      max: yAxisMaxValue,
    });
  };

  const handleIncrementValue = (event: { target: { value: any } }) => {
    const yAxisIntervalValue = event.target.value;
    setYAxisValue({
      ...yAxisValue,
      interval: yAxisIntervalValue < 0 ? 0 : parseInt(yAxisIntervalValue),
      scale: true,
    });
  };

  return (
    <>
      <div>
        <div className="diy-input-container">
          <div className="diyYValuesLabel">
            <label className="diyMinimunLabel">Minimum</label>
            <label>Maximum</label>
          </div>
          <div className="diyYValuesInput">
            <div className="diyYAxisNumberField">
              <GenericNumberInput
                onChangeMethod={handleMinValue}
                value={yAxisValue?.min || 0}
                label=""
              />
            </div>
            <div className="diyYAxisNumberField">
              <GenericNumberInput
                onChangeMethod={handleMaxValue}
                value={yAxisValue?.max || 100}
                label=""
              />
            </div>
          </div>
          {isInvalidMinMaxValue ? (
            <span className="diy-required-field">Invalid Minimum or Maximum value</span>
          ) : null}
        </div>
        <div className="diy-input-container">
          <GenericNumberInput
            onChangeMethod={handleIncrementValue}
            value={yAxisValue?.interval}
            label="Increments"
          />
        </div>
      </div>
    </>
  );
};

export default YAxisValueComponent;
